var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcDelete32 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M15.077 6a.95.95 0 0 0-.69.305c-.194.203-.31.488-.31.795v1.1h3.846V7.1c0-.307-.116-.592-.31-.795a.95.95 0 0 0-.69-.305zm4.846 2.2V7.1c0-.807-.305-1.59-.862-2.175A2.95 2.95 0 0 0 16.923 4h-1.846c-.812 0-1.58.34-2.138.925a3.15 3.15 0 0 0-.862 2.175v1.1H9a1 1 0 0 0-1 1v14.7c0 .807.305 1.59.862 2.175A2.95 2.95 0 0 0 11 27h10c.812 0 1.58-.34 2.138-.925A3.16 3.16 0 0 0 24 23.9V9.2a1 1 0 0 0-1-1zM10 10.2v13.7c0 .307.117.592.31.795A.95.95 0 0 0 11 25h10a.95.95 0 0 0 .69-.305c.193-.203.31-.488.31-.795V10.2z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M6 9a1 1 0 0 1 1-1h18a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1",
  clipRule: "evenodd"
})));
export default SvgIcDelete32;